import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "col-12 col-xl-3 d-xl-block fullscreen collapse searchfilter float-left",
  id: "searchfilter"
}
const _hoisted_2 = { id: "searchfilter-wrapper" }
const _hoisted_3 = { "aria-label": "Suchergebnisfilter" }
const _hoisted_4 = {
  key: 0,
  class: "nav flex-column"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "nav flex-column"
}
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 2,
  class: "nav flex-column"
}
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 3,
  class: "nav flex-column"
}
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  class: "col-12 content col-xl-9",
  id: "content",
  role: "main"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "area-search" }
const _hoisted_29 = { class: "formContainer" }
const _hoisted_30 = { class: "input-group input-group-lg searchbar searchbar-container mb-3" }
const _hoisted_31 = {
  for: "area-search-query",
  class: "sr-only"
}
const _hoisted_32 = ["placeholder"]
const _hoisted_33 = { class: "input-group-append" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "sr-only" }
const _hoisted_36 = {
  key: 0,
  id: "infoBlock",
  class: "infoBlock"
}
const _hoisted_37 = {
  key: 0,
  id: "infoBlockFound",
  class: "found searchresult-teaser text-center"
}
const _hoisted_38 = {
  key: 1,
  id: "infoBlockNotFound",
  class: "notFound searchresult-teaser text-center"
}
const _hoisted_39 = {
  key: 1,
  id: "infoBlock",
  class: "infoBlock"
}
const _hoisted_40 = {
  key: 0,
  id: "infoBlockFound",
  class: "found searchresult-teaser text-center"
}
const _hoisted_41 = {
  key: 1,
  id: "infoBlockNotFound",
  class: "notFound searchresult-teaser text-center"
}
const _hoisted_42 = {
  key: 2,
  class: "searchresult-teaser text-center"
}
const _hoisted_43 = {
  key: 3,
  class: "d-xl-none d-print-none searchresult-teaser text-center"
}
const _hoisted_44 = {
  href: "#searchfilter",
  class: "searchfilter-toggle",
  "data-toggle": "collapse",
  "aria-expanded": "false",
  "aria-controls": "searchfilter"
}
const _hoisted_45 = {
  key: 1,
  class: "searchresult-teaser text-center"
}
const _hoisted_46 = {
  key: 0,
  class: "row"
}
const _hoisted_47 = { class: "col-12 d-flex align-items-center justify-content-end flex-column flex-md-row" }
const _hoisted_48 = { class: "d-flex flex-column flex-sm-row" }
const _hoisted_49 = { class: "form-group mb-0 pl-3" }
const _hoisted_50 = {
  for: "sort",
  class: "sr-only"
}
const _hoisted_51 = { value: "date" }
const _hoisted_52 = { value: "relevance" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = ["aria-pressed"]
const _hoisted_55 = ["aria-pressed"]
const _hoisted_56 = {
  key: 0,
  "aria-label": "Suchergebnis",
  class: "resultContainer search-results-container"
}
const _hoisted_57 = { class: "list row list-unstyled overview overview-list overview-searchresult has-pagination" }
const _hoisted_58 = {
  key: 0,
  class: "loadWrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Page = _resolveComponent("Page")!
  const _component_Asset = _resolveComponent("Asset")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-right d-xl-none mt-3" }, [
          _createElementVNode("button", {
            class: "btn btn-link searchfilter-toggle collapsed",
            "data-toggle": "collapse",
            "data-target": "#searchfilter",
            "aria-expanded": "false"
          }, [
            _createElementVNode("span", {
              class: "icon icon-navigation_pfeil_schliessen_gross",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", { class: "sr-only" }, "Suchfilter ausblenden")
          ])
        ], -1)),
        _createElementVNode("nav", _hoisted_3, [
          (_ctx.showTopicFilter)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterTopicAll && _ctx.toggleFilterTopicAll(...args))),
                      href: "#"
                    }, _toDisplayString(_ctx.t('filter.topicAll')), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topicMap, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: key
                  }, [
                    (_ctx.topic.includes(key))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_6, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.toggleFilterTopic(key)),
                            href: "#"
                          }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTopicCount(value)), 9, _hoisted_7)
                        ]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.toggleFilterTopic(key)),
                          href: "#"
                        }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTopicCount(value)), 9, _hoisted_8))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showDocTypeFilter)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterDocTypeAll && _ctx.toggleFilterDocTypeAll(...args))),
                      href: "#"
                    }, _toDisplayString(_ctx.t('filter.docTypeAll')), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docTypeMap, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: key
                  }, [
                    (_ctx.docType.includes(key))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_11, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.toggleFilterDocType(key)),
                            href: "#"
                          }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getDocTypeCount(value)), 9, _hoisted_12)
                        ]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.toggleFilterDocType(key)),
                          href: "#"
                        }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getDocTypeCount(value)), 9, _hoisted_13))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTagsTopicFilter)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                _createElementVNode("li", _hoisted_15, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterTagsTopicAll && _ctx.toggleFilterTagsTopicAll(...args))),
                      href: "#"
                    }, "Alle Themen")
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsTopicMap, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: key
                  }, [
                    (_ctx.tagsTopic.includes(key))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_16, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.toggleFilterTagsTopic(key)),
                            href: "#"
                          }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTagsTopicCount(value)), 9, _hoisted_17)
                        ]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.toggleFilterTagsTopic(key)),
                          href: "#"
                        }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTagsTopicCount(value)), 9, _hoisted_18))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTagsTypeFilter)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                _createElementVNode("li", _hoisted_20, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilterTagsTypeAll && _ctx.toggleFilterTagsTypeAll(...args))),
                      href: "#"
                    }, "Alle Dokumente")
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagsTypeMap, ([key, value]) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "nav-item",
                    key: key
                  }, [
                    (_ctx.tagsType.includes(key))
                      ? (_openBlock(), _createElementBlock("strong", _hoisted_21, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.toggleFilterTagsType(key)),
                            href: "#"
                          }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTagsTypeCount(value)), 9, _hoisted_22)
                        ]))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.toggleFilterTagsType(key)),
                          href: "#"
                        }, _toDisplayString(value.label) + " " + _toDisplayString(_ctx.getTagsTypeCount(value)), 9, _hoisted_23))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_24, [
      _createElementVNode("h1", null, [
        (_ctx.pageTitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "title",
              id: "labelformodal",
              innerHTML: _ctx.sanitizeHtml(_ctx.pageTitle)
            }, null, 8, _hoisted_25))
          : _createCommentVNode("", true),
        (_ctx.pageSubtitle)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "subtitle",
              innerHTML: _ctx.sanitizeHtml(_ctx.pageSubtitle)
            }, null, 8, _hoisted_26))
          : _createCommentVNode("", true)
      ]),
      (_ctx.pageDescription)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "abstract",
            innerHTML: _ctx.sanitizeHtml(_ctx.pageDescription)
          }, null, 8, _hoisted_27))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
            action: "#",
            method: "get"
          }, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.t('search.headerViewSearchterm')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.queryString) = $event)),
                type: "search",
                id: "area-search-query",
                class: "search form-control",
                placeholder: _ctx.t('search.headerViewSearchterm')
              }, null, 8, _hoisted_32), [
                [_vModelText, _ctx.queryString]
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: "btn btn-brand1",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
                  type: "button",
                  id: "search-bottom-button",
                  title: _ctx.t('search.headerViewSearch2')
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", {
                    class: "icon icon-lupe",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.t('search.headerViewSearch2')), 1)
                ], 8, _hoisted_34)
              ])
            ])
          ], 32),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.result && _ctx.result.queryString)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      ((_ctx.result.numItems || 0) > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsAmountFound').replace('%TERM%', _ctx.result.queryString).replace('%AMOUNT%', (_ctx.result.numItems || 0).toString())), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsNotFound').replace('%TERM%', _ctx.result.queryString)), 1)
                          ]))
                    ]))
                  : (_ctx.result && _ctx.searchtype && _ctx.searchtype == 'docs')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        ((_ctx.result.numItems || 0) > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsAmountFoundNoQuerystring').replace('%AMOUNT%', (_ctx.result.numItems || 0).toString())), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchresultsNotFoundNoQuerystring')), 1)
                            ]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.t('search.searchresultsEmptySearchString')), 1)
                      ])),
                (_ctx.showTopicFilter || _ctx.showDocTypeFilter)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("a", _hoisted_44, _toDisplayString(_ctx.t('search.searchresultsOpenFilterString')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, " "))
        ]),
        (_ctx.result && (_ctx.result.numItems || 0) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('search.searchsortlabel')) + ":", 1),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t('search.searchsortlabel')), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "custom-select",
                      name: "sort",
                      id: "sort",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sortType) = $event)),
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSort && _ctx.onSubmitSort(...args)))
                    }, [
                      _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.t('search.searchsortdate')), 1),
                      _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.t('search.searchsortrelevance')), 1)
                    ], 544), [
                      [_vModelSelect, _ctx.sortType]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(`btn btn-link${_ctx.sortOrder == 'asc' ? '  text-primary' : ''}`),
                      "aria-pressed": _ctx.sortOrder == 'asc' ? 'true' : 'false',
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeSortOrder('asc')))
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-90" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.t('search.searchsortasc')), 1)
                    ], 10, _hoisted_54),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(`btn btn-link${_ctx.sortOrder == 'desc' ? '  text-primary' : ''}`),
                      "aria-pressed": _ctx.sortOrder == 'desc' ? 'true' : 'false',
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeSortOrder('desc')))
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "icon icon-navigation_pfeil_zurueck mr-1 d-inline-block rotate-n90" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.t('search.searchsortdesc')), 1)
                    ], 10, _hoisted_55)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_loading_container, { state: _ctx.state }, {
          default: _withCtx(() => [
            ((_ctx.result.numItems || 0) > 0)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_56, [
                  _createElementVNode("ul", _hoisted_57, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.result && _ctx.result.result && _ctx.result.result.resultList || []), (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item['system_s'] === 'website')
                          ? (_openBlock(), _createBlock(_component_Page, {
                              key: 0,
                              item: item,
                              highlight: _ctx.getHighlight(item),
                              nodeLink: _ctx.getNodeLink(item),
                              ancestors: _ctx.getAncestors(item),
                              badges: _ctx.getBadges(item)
                            }, null, 8, ["item", "highlight", "nodeLink", "ancestors", "badges"]))
                          : _createCommentVNode("", true),
                        (item['system_s'] === 'dam')
                          ? (_openBlock(), _createBlock(_component_Asset, {
                              key: 1,
                              item: item,
                              highlight: _ctx.getHighlight(item),
                              nodeLink: _ctx.getNodeLink(item),
                              dependants: _ctx.getDependants(item),
                              badges: _ctx.getBadges(item)
                            }, null, 8, ["item", "highlight", "nodeLink", "dependants", "badges"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("div", {
                    class: "loader",
                    "aria-hidden": "true"
                  }, null, -1)),
                  (!_ctx.isLastPage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createVNode(_component_loading_container, { state: _ctx.pagingState }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "loadMore",
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.loadNext && _ctx.loadNext(...args)))
                            }, _toDisplayString(_ctx.t('search.searchresultsLoadmoreTitle')), 1)
                          ]),
                          _: 1
                        }, 8, ["state"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ])
  ], 64))
}